import { Enrollment } from "@api/types/enrollments";
import { FC } from "react";

import CourseCertificateDownload from "@components/CourseCertificateDownload";
import CourseDigitalWalletButton from "@components/CourseDigitalWalletButton";
import EnrolledCourseDetails from "@components/EnrolledCourseDetails";
import EnrolledCourseImage from "@components/EnrolledCourseImage";
import LaunchCourseButton from "@components/LaunchCourseButton";

const EnrolledCourse: FC<{ enrollment: Enrollment }> = ({ enrollment }) => {
  return (
    <>
      <div className="EnrolledCourse">
        <div className="thumbnail">
          <EnrolledCourseImage enrollment={enrollment} />
        </div>
        <div className="details">
          <EnrolledCourseDetails enrollment={enrollment} />
        </div>
        <div className="actions">
          <div className="row">
            <LaunchCourseButton node={enrollment.node} />
          </div>
          <div className="row">
            <CourseCertificateDownload enrollment={enrollment} />
          </div>
          <div className="row">
            <CourseDigitalWalletButton enrollment={enrollment} />
          </div>
        </div>
      </div>
      {/* language=CSS */}
      <style jsx>
        {`
          .EnrolledCourse {
            display: grid;
            grid-template-columns: repeat(12, 1fr);
          }

          .thumbnail {
            grid-column: 1/13;
            margin-bottom: 20px;
          }

          .details {
            grid-column: 1/13;
            margin-bottom: 20px;
          }

          .actions {
            grid-column: 1/13;
            margin-bottom: 20px;
          }

          .actions .row {
            margin-bottom: 10px;
          }

          @media screen and (min-width: 768px) {
            .EnrolledCourse {
              grid-column-gap: 40px;
            }

            .thumbnail {
              grid-column: 1/4;
              margin-bottom: 0;
            }

            .details {
              grid-column: 4/10;
              margin-bottom: 0;
            }

            .actions {
              grid-column: 10/13;
              margin-bottom: 0;
            }
          }
        `}
      </style>
    </>
  );
};

export default EnrolledCourse;
